import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Settings {
    public value?: any;

    constructor(
        private readonly http: HttpClient
    ) {}

    public load(): Observable<any> {
        return this.http.get('/assets/config.json')
            .pipe(tap(cfg => (this.value = cfg)));
    }
}
